import { LayoutModule } from 'src/app/layout/layout.module'
import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { PaymentRoutingModule } from './payment-routing.module'
import { PaymentEffects } from './payment.effects'
import * as fromPayment from './payment.reducer'
import { PaymentSerializer } from './payment.serializer'
import { PaymentService } from './payment.service'
import { GiftCardModule } from './gift-card/gift-card.module'
import { PaymentsTableComponent } from './payments-table/payments-table.component'

@NgModule({
  imports: [
    CommonModule,
    PaymentRoutingModule,
    SharedModule,
    LayoutModule,
    StoreModule.forFeature(
      fromPayment.FEATURE_NAME,
      fromPayment.paymentReducer
    ),
    EffectsModule.forFeature([PaymentEffects]),
    GiftCardModule
  ],
  declarations: [PaymentsTableComponent],
  exports: [GiftCardModule, PaymentsTableComponent],
  providers: [
    PaymentService,
    {
      provide: PaymentSerializer,
      useClass: PaymentSerializer
    }
  ]
})
export class PaymentModule {}
